import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dotNetToDate', standalone: true })
export class DotNetToDatePipe implements PipeTransform {
  private static readonly RE = /\/Date\((-?\d+)([+-]\d{4})?\)\//;

  transform(value: unknown): Date | null {
    if (value == null) return null;
    if (value instanceof Date) return value;
    if (typeof value === 'number') return new Date(value);

    if (typeof value === 'string') {
      const m = DotNetToDatePipe.RE.exec(value);
      if (m) {
        const ticks = parseInt(m[1], 10);
        if (m[2]) {
          // WCF DataContractJsonSerializer: ticks are local-time milliseconds.
          // The offset (e.g. +0200) tells us the timezone — subtract it to get UTC.
          const sign = m[2][0] === '+' ? 1 : -1;
          const offsetMs = sign * (parseInt(m[2].slice(1, 3), 10) * 60 + parseInt(m[2].slice(3, 5), 10)) * 60_000;
          return new Date(ticks - offsetMs);
        }
        return new Date(ticks); // no offset → already UTC epoch ms
      }
      // Fallback for ISO strings (e.g. "2026-05-11T10:30:00").
      // Without a timezone suffix the spec treats them as local time, but eDesk
      // sends UTC values without 'Z', so we append it explicitly.
      const iso = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(value) && !/(Z|[+-]\d{2}:?\d{2})$/.test(value)
        ? value + 'Z'
        : value;
      const d = new Date(iso);
      return isNaN(d.getTime()) ? null : d;
    }
    return null;
  }
}
